import api from '@/services/api';
import { handleException } from '@/utils/exception';
import { toast } from 'react-toastify';

import {
  type CreateJiraEpicDto,
  type JiraComponent,
  type JiraEpicSearchResult,
  type JiraIssueResponse,
  type JiraStatus,
  type JiraTeam,
  type JiraVersion,
} from '../types';

const BASE_URL = 'jira';

export const getJiraStatus = async (): Promise<JiraStatus> => {
  return await api.get<JiraStatus>(`${BASE_URL}/status`);
};

export const getJiraConnectUrl = async (): Promise<string> => {
  const { url } = await api.get<{ url: string }>(`${BASE_URL}/connect`);
  return url;
};

export const getJiraVersions = async (): Promise<JiraVersion[]> => {
  return await api.get<JiraVersion[]>(`${BASE_URL}/versions`);
};

export const getJiraTeams = async (): Promise<JiraTeam[]> => {
  return await api.get<JiraTeam[]>(`${BASE_URL}/teams`);
};

export const getJiraComponents = async (): Promise<JiraComponent[]> => {
  return await api.get<JiraComponent[]>(`${BASE_URL}/components`);
};

export const createJiraEpic = async (dto: CreateJiraEpicDto): Promise<JiraIssueResponse> => {
  try {
    const result = await api.post<JiraIssueResponse>(`${BASE_URL}/issues`, dto);
    toast.success('Jira epic created successfully');
    return result;
  } catch (e) {
    toast.error(handleException(e, 'Failed to create Jira epic'));
    throw e;
  }
};

export const searchJiraEpicBySummary = async (summary: string): Promise<JiraEpicSearchResult | null> => {
  try {
    const result = await api.get<JiraEpicSearchResult | null>(
      `${BASE_URL}/epics/search?summary=${encodeURIComponent(summary)}`,
    );
    return result?.key ? result : null;
  } catch {
    return null;
  }
};
